import { render, staticRenderFns } from "./ArticleEdit.vue?vue&type=template&id=4100c520&scoped=true&"
import script from "./ArticleEdit.vue?vue&type=script&lang=js&"
export * from "./ArticleEdit.vue?vue&type=script&lang=js&"
import style0 from "./ArticleEdit.vue?vue&type=style&index=0&id=4100c520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4100c520",
  null
  
)

export default component.exports